import {
  GetProAlertsResponse,
  ProAlertCreateRequest,
  ProAlertCreateResponse,
  ProAlertDeleteRequest,
  ProAlertDeleteResponse,
  ProAlertPatchEmailsResponse,
  ProAlertPatchMutedResponse,
  ProAlertPatchRequest,
} from '../models/pro.model';
import { wrapRequest } from './base';

export const getProAlerts = async (): Promise<GetProAlertsResponse> =>
  wrapRequest('get', 'north_standard', `/alerts`);

export const createProAlert = async (
  payload: ProAlertCreateRequest
): Promise<ProAlertCreateResponse> =>
  wrapRequest('post', 'north_standard', `/alerts`, {
    body: payload,
  });

export const deleteProAlert = async (
  payload: ProAlertDeleteRequest
): Promise<ProAlertDeleteResponse> =>
  wrapRequest('del', 'north_standard', `/alerts`, {
    body: payload,
  });

export const updateProAlertMuted = async (
  payload: ProAlertPatchRequest
): Promise<ProAlertPatchMutedResponse> =>
  wrapRequest('patch', 'north_standard', `/alerts`, {
    body: payload,
  });

export const updateProAlertEmails = async (
  payload: ProAlertPatchRequest
): Promise<ProAlertPatchEmailsResponse> =>
  wrapRequest('patch', 'north_standard', `/alerts`, {
    body: payload,
  });
